export default __webpack_public_path__ + "static/media/character_11.7406d3be.png";